<template>
    <div>
        <div class="group">
            <!-- <div class="group-title">患者文书</div> -->
            <div class="group-items">
                <div class="group-item" v-for="item in documentList" :key="item.doc_id" @click="handleItem(item)">
                    <span>
                        {{ item.paper_name }}
                    </span>
                </div>
            </div>
            <div class="empty" v-if="!documentList.length">暂无数据</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `DocList`,
    props: {
        surgeryId: Number,
        surgeryInfo: Object,
        visible: { type: Boolean }
    },
    components: { },
    data() {
        return {
            activeDoc: {
                // 当前打开的文书一些内容
                dialogFormVisible: false,
                docguid: ``,
                surgeryInfo: this.surgeryInfo,
                surgeryId: ``,
                docno: 0,
                doc: null
            },
            documentList: [], // 文书明细
            isPagination: this.$root.MobileDocIsPagination == `1`,
            catoken: sessionStorage.getItem(`caToken`)

        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`currentUser`])
    },
    mounted() {
        let that = this
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            if (that.surgeryInfo) {
                that.loadDicDocManagementList()
            }
        })
    },
    methods: {
        afterDocumentSaved(data) {
            this.activeDoc.dialogFormVisible = false
        },
        handleItem(item) {
            sessionStorage.setItem(`activeDoc`, JSON.stringify(item))
            this.$router.push({ name: `IframeDoc`, query: { docId: item.doc_id, surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo } }).catch(err => err)
        },
        loadDicDocManagementList() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/MobilePaper/MobilePaper/Get`)
                req.then(dicDocManagementList => {
                    that.documentList = dicDocManagementList
                    resolve(that.documentList)
                }).catch(e => {
                    console.log(e)
                })
            })
        }
    },
    beforeDestroy() {
    },
    watch: {
        visible: function(newUrl, oldUrl) {
            if (this.visible) {
                if (this.surgeryInfo) {
                    this.loadDicDocManagementList()
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.group {
    padding: 16px;
    .group-title {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
        font-weight: 500;
        white-space: nowrap;
        text-align: left;
        margin-bottom: 12px;
    }
    .group-items {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .group-item-info {
            padding: 6px 8px;
            color: #04b9a8;
            font-size: 14px;
            border-radius: 4px;
            background-color: rgb(#04b9a8, 0.1);
        }
        .group-item {
            padding: 6px 8px;
            color: #6d6c71;
            font-size: 14px;
            border-radius: 4px;
            background-color: rgb(#6d6c71, 0.1);
        }
    }
    .empty {
        font-size: 14px;
        color: #ddd;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/DocList.vue